import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import ProductShowcase from "@/components/ProductShowcase";
import Features from "@/components/Features";
import SizeGuide from "@/components/SizeGuide";
import Footer from "@/components/Footer";

export default function HomePage() {
    return (
        <div className="min-h-screen bg-spidey-bg">
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <ProductShowcase />
                <Features />
                <SizeGuide />
            </main>
            <Footer />
        </div>
    );
}
